import { Stack } from "@mantine/core";

import { useStartGoogleSignIn } from "../../api/generated/endpoints/identity/identity";
import { leaveFor } from "../../platform/browser";
import { ErrorAlert } from "../../platform/ErrorAlert";
import { AuthDefaultButton } from "../../ui/AuthShell";
// Google's own "G", from its sign-in branding guidelines
// (https://developers.google.com/identity/branding-guidelines, g-logo.png), shown unaltered at
// 18px as the guidelines ask (design-system.md decision 29).
import googleG from "../../ui/assets/google-g.png";

/**
 * Starts Google's authorization-code flow (A1 decision 2): the API sets the attempt cookie and
 * answers with Google's URL, and Google returns the browser to /sign-in/google.
 */
export function GoogleButton({ redirect }: { redirect: string }) {
  const start = useStartGoogleSignIn();
  const onClick = () =>
    start.mutate(
      { data: { redirect } },
      { onSuccess: ({ authorization_url }) => leaveFor(authorization_url) },
    );
  return (
    <Stack gap={12}>
      {/* Success keeps the spinner: the browser is on its way to Google. */}
      <AuthDefaultButton
        leftSection={<img src={googleG} alt="" width={18} height={18} />}
        onClick={onClick}
        loading={start.isPending || start.isSuccess}
      >
        Sign in with Google
      </AuthDefaultButton>
      {start.isError ? <ErrorAlert error={start.error} /> : null}
    </Stack>
  );
}
